<script lang="ts">
	import * as Breadcrumb from '$lib/components/ui/breadcrumb/index';
	import { Separator } from '$lib/components/ui/separator/index';
	import * as Sidebar from '$lib/components/ui/sidebar/index';
	import { page } from '$app/stores';

	// Create derived breadcrumb segments from the URL
	const pathSegments = $derived(
		$page.url.pathname
			.split('/')
			.filter(Boolean)
			.map((segment) => ({
				label: segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' '),
				href: '/' + segment
			}))
	);
</script>

<header class="container flex h-16 shrink-0 items-center gap-2">
	<div class="flex items-center gap-2">
		<Sidebar.Trigger />
		<Separator orientation="vertical" class="mr-2 h-4" />
		<Breadcrumb.Root>
			<Breadcrumb.List>
				<Breadcrumb.Item>
					<Breadcrumb.Link href="/">Home</Breadcrumb.Link>
				</Breadcrumb.Item>

				{#each pathSegments as segment, i}
					<Breadcrumb.Separator />
					<Breadcrumb.Item>
						{#if i === pathSegments.length - 1}
							<Breadcrumb.Page>{segment.label}</Breadcrumb.Page>
						{:else}
							<Breadcrumb.Link
								href={pathSegments
									.slice(0, i + 1)
									.map((s) => s.href)
									.join('')}
							>
								{segment.label}
							</Breadcrumb.Link>
						{/if}
					</Breadcrumb.Item>
				{/each}
			</Breadcrumb.List>
		</Breadcrumb.Root>
	</div>
</header>
